import { GzCheckboxWebComponent } from './component/GzCheckboxWebComponent';

export { GzCheckboxWebComponent };

/**
 *  Examples:
 *  Default checkbox => <gz-checkbox label="Option one" name="option_one" value="option one"></gz-checkbox>
 *
 *  Default checked checkbox =>
 *  <gz-checkbox checked label="Option two" name="option_two" value="option two"></gz-checkbox>
 *
 *  Default disabled checkbox =>
 *  <gz-checkbox label="Option three" name="option_three" value="option three" disabled></gz-checkbox>
 *
 *  Negative checked checkbox =>
 *  <gz-checkbox checked color="negative" label="Option two" name="option_two" value="option two"></gz-checkbox>
 *
 */
